<app-header></app-header>

<div class="container-fluid">
    <div style="margin-top: 100px;">
        <div class="col-12 text-center">
            <h1>Disclosure Statement</h1>

            <div class="container">
                <p><strong>SNP Money</strong> is a brand name owned by SNP WEALTH PRIVATE LIMITED.</p>

                <p>
                    By accessing this website, you acknowledge that you have read, understood, and agreed to be legally bound by the terms outlined in this disclaimer. 
                    This website is created for informational purposes only; nothing contained herein should be construed as investment advice or a personal recommendation to buy, sell, or hold any investment product. 
                    We make no representation or warranty (expressed or implied) regarding the advisability of investing in any investment product or its future performance.
                </p>

                <p>
                    All mutual funds are subject to market risks. We strongly advise investors to carefully read all scheme-related documents prior to investing, including the Scheme Information Document (SID), Statement of Additional Information (SAI), and Key Information Memorandum (KIM). 
                    The value of investments may fluctuate due to market changes, and this website is not intended to predict actual performance or success of any scheme or investment product. 
                    Past performance is not indicative of future returns.
                </p>

                <p>
                    This website may present indicative summaries, analyses, and information concerning various investment products, including mutual fund schemes. 
                    Unless otherwise specified, all analyses, expense ratios, returns, NAV, etc., are historical and for illustration purposes only, and are subject to change. 
                    This website does not claim to disclose all risks and significant issues related to any mutual fund.
                </p>

                <p>
                    While we have exercised due care in compiling the data and contents provided herein, no representation is made regarding the reasonableness of the assumptions or the accuracy or completeness of any data concerning past performance of schemes, historical analyses, or any other analysis of investment products. 
                    We expressly state that we cannot be held liable for any damages (monetary, legal, or otherwise) resulting from any error, omission, interruption, deletion, defect, or failure. 
                    Additionally, we bear no financial liability to any user for the use of the information on our website. Please note that the transaction data and other information may be obtained from third-party feeds, and we are not responsible for verifying their accuracy. 
                    The information on this website may be updated periodically.
                </p>

                <p>
                    We are under no obligation to provide investment advice regarding any investment product. However, concerning mutual fund schemes, we strive to distribute only those mutual fund products deemed suitable and appropriate for you, as permitted under the AMFI Guidelines and relevant circulars. 
                    We do not make any warranty (express or implied) regarding any investment product and shall not be liable for any losses or damages resulting from investment in any product due to market loss. 
                    Please be advised that we are not registered investment advisers and do not provide investment advice on any investment product.
                </p>

                <p>
                    We consider ourselves and intend to be subject to the jurisdiction only of the courts of Pune, India. If you disagree with any of the disclaimers or terms and conditions provided on the website, we kindly ask you to refrain from accessing the material and exit the website immediately.
                </p>

                <p><strong>SNP WEALTH PRIVATE LIMITED</strong> is a Mutual Fund Distributor registered with the Association of Mutual Funds in India (AMFI), holding ARN No 173623.</p>

                <p>
                    The detailed disclosure of commissions earned by SNP WEALTH PRIVATE LIMITED from various mutual fund houses, in accordance with existing regulations, typically includes the following information:
                </p>

                <p>
                    The rates mentioned above are indicative and will be updated periodically based on actual rates received from the respective Asset Management Companies (AMCs). 
                    Commissions are subject to clawback and are also subject to GST. These rates are subject to change without prior consent and at the discretion of the agreement between SNP WEALTH PRIVATE LIMITED and the respective AMCs. 
                    Commission details will be regularly updated on the website; customers are advised to check the details before making any investments. 
                    SNP WEALTH PRIVATE LIMITED operates as an opt-out distributor, meaning no transaction charges will be deducted by AMCs from clients' investment amounts for transactions conducted under the ARN code. 
                    Details of scheme-level commissions on mutual funds are available with your service relationship manager and can be provided upon request.
                </p>

                <p>Investments in mutual funds are subject to market risks; customers should read the scheme-related documents carefully.</p>

                <h3>Registration Numbers</h3>
                <table class="registration-table table">
                    <thead>
                        <tr>
                            <th>Registration Type</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>CIN</td>
                            <td>U74999PN2020PTC196043</td>
                        </tr>
                        <tr>
                            <td>AMFI Registration No</td>
                            <td>173623</td>
                        </tr>
                        <tr>
                            <td>Date of Initial Registration with AMFI</td>
                            <td>04/12/2020</td>
                        </tr>
                        <tr>
                            <td>Current Validity of ARN</td>
                            <td>03/12/2026</td>
                        </tr>
                    </tbody>
                </table>

                <h3>Escalation Matrix</h3>
                <table class="escalation-table table">
                    <thead>
                        <tr>
                            <th>Position</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Contact No</th>
                            <th>Email</th>
                            <th>Working Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Head of Operations</td>
                            <td>Sachin Srivastava</td>
                            <td>Office No 254, Vision 9 Mall, Kunal Icon Road, Pimple Saudagar, Pune 411027</td>
                            <td>7796355355</td>
                            <td><a href="mailto:service@snpmoney.com">service&#64;snpmoney.com</a></td>
                            <td>Mon – Sat; 10:00 a.m. to 6:00 p.m.</td>
                        </tr>
                        <tr>
                            <td>Director</td>
                            <td>Sunil Srivastava</td>
                            <td>Office No 254, Vision 9 Mall, Kunal Icon Road, Pimple Saudagar, Pune 411027</td>
                            <td>9372656044</td>
                            <td><a href="mailto:sunil@snpmoney.com">sunil&#64;snpmoney.com</a></td>
                            <td>Mon – Sat; 10:00 a.m. to 6:00 p.m.</td>
                        </tr>
                    </tbody>
                </table>

                <p>
                    If your complaint is not addressed to your satisfaction, you may lodge a complaint with AMFI at 
                    <a href="https://www.amfiindia.com" target="_blank">https://www.amfiindia.com</a> or SEBI at 
                    <a href="https://www.sebi.gov.in" target="_blank">https://www.sebi.gov.in</a>.
                </p>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
